<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <list-page
        :columns="columns"
        :headers="headers"
        :popupComponent="popupComponent"
        :show-add-button="false"
        scrollable="site_url"
        sort="site_url"
        title="WP User Access"
        icon="mdi-lock"
        stateendpoint="wpAccess.wpSites"
        :actions="actions"
        :show-default-action-buttons="false"
        :action-buttons="actionButtons"
    />
  </div>
</template>
<script>
import ListPage from "../components/ListPage";
import WPAccessPopup from "../components/popups/WPAccessPopup";

export default {
  name: 'WPAccess',
  metaInfo: {
    title: 'zetrank.com',
    titleTemplate: 'Admin Dashboard - WP Access | %s',
    meta: [
      { name: 'robots', content: 'noindex' },
      { name: 'googlebot', content: 'noindex' }
    ]
  },
  components: {ListPage},
  data() {
    return {
      headers: [
        {
          text: 'Site URL',
          value: 'siteUrl'
        },
        {
          text: 'WP Username',
          value: 'wpUsername'
        },
        {
          text: '', value: 'actions', sortable: false
        }
      ],
      columns: [
        {value: 'siteUrl'},
        {value: 'wpUsername'},
        {value: 'wpPassword'},
        {value: 'action'},
      ],
      actions: {
        load: 'loadWPSites',
        update: 'updateWPSite'
      },
      actionButtons: [
        {
          category: 'edit',
          icon: 'mdi-lock-open',
          color: '',
          text: 'WP Access',
          clickHandler: 'editItem'
        }
      ]
    }
  },
  computed: {
    popupComponent() {
      return WPAccessPopup;
    }
  }
}
</script>
